module.exports = __webpack_public_path__ + "img/MariSolMalibu_logo_primary_white.7e796818.svg";